import { render, staticRenderFns } from "./CBlockImgtxt.vue?vue&type=template&id=673da5a7&"
import script from "./CBlockImgtxt.vue?vue&type=script&lang=ts&"
export * from "./CBlockImgtxt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports